import {
  FUND_SUMMARY_SPREADSHEET_COLUMNS,
  FUND_SUMMARY_SPREADSHEET_HEADERS,
  FUND_SUMMARY_SPREADSHEET_PROCESS_MANAGEMENT_TITLE,
} from 'pages/Funds/common/constants/fundSummary/sheetTitles';

const getAdjustedColumns = (isProcessManagementEnabled: boolean) => {
  if (isProcessManagementEnabled) {
    return FUND_SUMMARY_SPREADSHEET_COLUMNS;
  }

  type FundSummaryColumns = typeof FUND_SUMMARY_SPREADSHEET_COLUMNS;
  type AdjustedFundSummaryColumns = Omit<FundSummaryColumns, 'PROCESS_MANAGEMENT'>;
  const processManagementColumnIndex = FUND_SUMMARY_SPREADSHEET_HEADERS.findIndex(
    ({ value }) => value === FUND_SUMMARY_SPREADSHEET_PROCESS_MANAGEMENT_TITLE
  );
  const columnsWithoutProcessManagement = Object.fromEntries(
    Object.entries(FUND_SUMMARY_SPREADSHEET_COLUMNS).filter(([, value]) => value !== processManagementColumnIndex)
  ) as AdjustedFundSummaryColumns;
  let adjustedColumns: AdjustedFundSummaryColumns = { ...columnsWithoutProcessManagement };
  type FundSummaryColumnsKey = keyof AdjustedFundSummaryColumns;

  Object.entries(columnsWithoutProcessManagement).forEach(([key, value]) => {
    const columnKey = key as FundSummaryColumnsKey;

    // When PROCESS_MANAGEMENT is excluded, every column after COMPANY_NAME shifts left by one index.
    if (columnKey !== Object.keys(columnsWithoutProcessManagement)[0]) {
      adjustedColumns = { ...adjustedColumns, [columnKey]: value - 1 };
    }
  });

  return adjustedColumns;
};

export default getAdjustedColumns;
